import request from '@/utils/request'
import qs from 'qs'


export function updateStudentInfoApi(params) {
  return request({
    url: 'api/student/updateStudentInfo',
    method: 'post',
    data: params
  })
}

export function logoutApi(params) {
  return request({
    url: 'api/student/logout',
    method: 'get',
    params: params
  })
}

export function versionApi(params) {
  return request({
    url: '/api/basis/getConfigInfo',
    method: 'get',
    params: {
		key:'version',
		...params
	}
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js